export const theme = {
  borderColor: Styles.color.primary,
  disabledBorderColor: Styles.color.disabledBackground,
};
